module.exports = __webpack_public_path__ + "static/img/PencilsForKids_10YrAnniv_Logo.d9d4b6b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PencilsForKids_10YrAnniv_Logo.svg
// module id = 343
// module chunks = 2